<template>
  <div class="site-admin-edit">
    <user-details-edit-card :user="user"
                            :can-reset-password="false"
                            @submit="onUserSubmit">
      <template v-slot:after-form>
        <base-form :title="$t('settings.siteAdmins.changeRole')"
                   :show-back-button="false"
                   @submit.prevent="onRoleSubmit">
          <fg-input class="w-full" :label="$t('generic.role')">
            <role-autocomplete v-model="model.role"
                               class="w-full"
                               filter-query="admin"
                               exclude-query="admin-super-admin">
            </role-autocomplete>
          </fg-input>
        </base-form>
      </template>
    </user-details-edit-card>
  </div>
</template>
<script>
  import UserService from 'src/services/UserService'
  import SiteAdminService from 'src/services/SiteAdminService'
  import RoleAutocomplete from 'src/components/Autocomplete/RoleAutocomplete'
  import UserDetailsEditCard from 'src/views/admin/contacts/users/UserDetails/UserDetailsEditCard'

  export default {
    name: 'site-admins-edit',
    components: {
      RoleAutocomplete,
      UserDetailsEditCard
    },
    data () {
      return {
        user: {},
        model: {
          role: {
            name: this.$route.query.role
          }
        }
      }
    },
    methods: {
      async onRoleSubmit () {
        let roleName = this.model.role.name
        await SiteAdminService.update(this.$route.params.id, {
          role: roleName
        })
      },
      async onUserSubmit (id, data) {
        await UserService.update(id, data)
      },
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await UserService.getById(id)
        let user = res.data
        if (user) {
          next(vm => {
            vm.user = user
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
<style scoped>
  .site-admin-edit /deep/ .el-select.role-autocomplete {
    @apply w-full max-w-full;
  }
</style>
